import { render, staticRenderFns } from "./BalanceAdd.vue?vue&type=template&id=5f27279a&scoped=true"
import script from "./BalanceAdd.vue?vue&type=script&lang=js"
export * from "./BalanceAdd.vue?vue&type=script&lang=js"
import style0 from "./BalanceAdd.vue?vue&type=style&index=0&id=5f27279a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27279a",
  null
  
)

export default component.exports